import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export default function Services({ services }) {
  return (
    <section id="services" className="relative py-24 sm:py-32" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="mb-14"
        >
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-gold mb-4" data-testid="services-eyebrow">What we do</p>
          <h2 className="font-display font-bold italic uppercase text-4xl sm:text-5xl lg:text-6xl text-white leading-[0.95]" data-testid="services-heading">
            Exterior systems, <span className="gold-text">mastered.</span>
          </h2>
        </motion.div>

        <div className="border-t border-gold/10">
          {(services || []).map((s, i) => (
            <motion.a
              key={s.num || i}
              href="#contact"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.06 }}
              className="group grid md:grid-cols-12 gap-4 md:gap-6 items-center py-8 sm:py-10 border-b border-gold/10 hover:bg-storm-800/40 transition-colors px-2 sm:px-4 -mx-2 sm:-mx-4 rounded-lg"
              data-testid={`service-row-${i}`}
            >
              <div className="md:col-span-2 font-display font-bold text-6xl sm:text-7xl text-stroke-gold leading-none select-none">
                {s.num}
              </div>
              <div className="md:col-span-4">
                <h3 className="font-display font-bold uppercase italic text-3xl sm:text-4xl text-white group-hover:text-gold transition-colors">
                  {s.title}
                </h3>
              </div>
              <div className="md:col-span-5">
                <p className="text-slate-400 text-sm sm:text-base leading-relaxed">{s.desc}</p>
                <div className="mt-3 flex flex-wrap gap-2">
                  {(s.tags || "").split(",").filter(Boolean).map((t) => (
                    <span key={t} className="font-mono text-[10px] uppercase tracking-[0.15em] border border-gold/25 text-gold/90 rounded-full px-3 py-1">
                      {t.trim()}
                    </span>
                  ))}
                </div>
              </div>
              <div className="hidden md:flex md:col-span-1 justify-end">
                <ArrowUpRight size={28} className="text-gold/40 transition-all group-hover:text-gold group-hover:translate-x-1 group-hover:-translate-y-1" />
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
